
const _ = require('lodash');
const $ = require('jquery');
require('corejs-typeahead');

/*
 * Extended typeahead
 * See `DEFAULTS` for comments on new options
 */

const DEFAULTS = {
	// Always keep cursor visible (when selecting suggestions with arrow keys)
	scrollToCursor: true,

	// Highlight matches in suggestions
	highlight: true,

	// Easier `done` callback convention
	sourceCallbacksHack: true,

	// Disable hint (background suggestion text) by default
	hint: false,
};

const typeahead = $.fn.typeahead;

module.exports = $.fn.typeahead = function (opts /* ...dataSources */) {
	if ('string' === typeof opts) {
		return typeahead.apply(this, arguments);
	}

	opts = _.defaults({}, opts, DEFAULTS);

	const args = [ opts ].concat([].slice.call(arguments, 1));

	if (opts.sourceCallbacksHack) {
		$.map(args.slice(1), function (src) {
			const sourceFn = src.source;
			if ('function' === typeof sourceFn) {
				src.source = function (q, doneSync, doneAsync) {
					const doneAnyhow = function () {
						const args = arguments;
						setTimeout(function () {
							doneAsync(...args);
						}, 0);
					};
					return sourceFn(q, doneAnyhow, doneAnyhow);
				};
			}
		});
	}

	const ret = typeahead.apply(this, args);

	if (opts.scrollToCursor) {
		ret.on('typeahead:cursorchange', function () {
			// Scroll to cursor
			const $cursor = $(this).closest('.twitter-typeahead').find('.tt-cursor');
			if (!$cursor[0]) {
				return;
			}
			const $menu = $cursor.parent();

			let elTop, elBottom, elHeight, menuScrollTop, menuHeight;

			elHeight = $cursor.outerHeight(true);
			elTop = $cursor.position().top;
			elBottom = elTop + elHeight;
			menuScrollTop = $menu.scrollTop();
			menuHeight = $menu.outerHeight(true);

			if (elTop < elHeight) {
				$menu.scrollTop(menuScrollTop + elTop - elHeight);
			}			else if (menuHeight < elBottom) {
				$menu.scrollTop(menuScrollTop + (elBottom - menuHeight));
			}
		});
	}

	$.map(['background-color', 'background-image'], function (prop) {
		ret.each(function () {
			if (this.style.removeProperty) {
				this.style.removeProperty(prop);
			} else {
				this.style.removeAttribute(prop);
			}
		});
	});

	return ret;
};


